import React, { MouseEvent } from 'react';

export const updateFoilPosition = (
  event: MouseEvent<HTMLDivElement>,
  easingValue: number,
  foilRef: React.RefObject<HTMLDivElement>,
  overlayRef: React.RefObject<HTMLSpanElement>
) => {
  const { offsetX: targetX, offsetY: targetY } = event.nativeEvent;

  const newXValue = targetX / easingValue;
  const newYValue = targetY / easingValue;

  if (foilRef.current) {
    // eslint-disable-next-line no-param-reassign
    foilRef.current.style.backgroundPositionX = `${newXValue}px  `;
  }

  if (overlayRef.current) {
    // eslint-disable-next-line no-param-reassign
    overlayRef.current.style.backgroundPositionY = `${newYValue}px`;
  }
};
